import { createTheme } from '@one-thd/sui-atomic-components';

const SecondaryHolidayLightGreen = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

SecondaryHolidayLightGreen.palette['--sui-palette-background-primary'] = '126 187 163';

export { SecondaryHolidayLightGreen };